import {
  useCrmManagement_AdminInvestorExtensionSchemaQuery,
  useCrmManagement_InvestorExtensionSchemaQuery,
} from '../graphql/__generated__';

type UseInvestorExtensionSchemaProps = {
  tenantId?: string;
  isSysAdmin: boolean;
};

export function useInvestorExtensionSchema({
  tenantId,
  isSysAdmin,
}: UseInvestorExtensionSchemaProps) {
  const customerResponse = useCrmManagement_InvestorExtensionSchemaQuery({
    skip: isSysAdmin,
  });

  const adminResponse = useCrmManagement_AdminInvestorExtensionSchemaQuery({
    variables: { tenantId: tenantId ?? '' },
    skip: !isSysAdmin || !tenantId,
  });

  const investorExtensionSchema =
    (isSysAdmin
      ? adminResponse.data?.adminInvestorExtensionSchema
      : customerResponse.data?.investorExtensionSchema) ?? [];

  const headers = investorExtensionSchema
    .map(row => row.displayName)
    .filter((value): value is string => Boolean(value))
    .map(displayName => `EXT_${displayName}`);

  return {
    headers,
    loading: isSysAdmin ? adminResponse.loading : customerResponse.loading,
    error: isSysAdmin ? adminResponse.error : customerResponse.error,
  };
}
